'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  position: relative;\n  border-style: solid;\n  border-width: 0px;\n  border-top-width: 1px;\n  border-color: #f2f2f2;\n'], ['\n  width: 100%;\n  position: relative;\n  border-style: solid;\n  border-width: 0px;\n  border-top-width: 1px;\n  border-color: #f2f2f2;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 14px;\n  color: #898989;\n  background-color: #ffffff;\n  padding: 8px;\n'], ['\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 14px;\n  color: #898989;\n  background-color: #ffffff;\n  padding: 8px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _View = require('../View');

var _View2 = _interopRequireDefault(_View);

var _Text = require('../../fundamentals/Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject);

var Title = (0, _styledComponents2.default)(_Text2.default)(_templateObject2);

var ruleWithText = function ruleWithText(props) {
  return _react2.default.createElement(
    Content,
    props,
    props.text && _react2.default.createElement(
      Title,
      null,
      props.text
    )
  );
};

ruleWithText.propTypes = {
  text: _propTypes2.default.string,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.string
};

ruleWithText.defaultProps = {
  color: '#f2f2f2'
};

exports.default = ruleWithText;